import { z } from "zod";

export const InformacaoFaturamentoSchema = z.object({
    idInformacaoFaturamento: z.coerce.number(),
    idCentroCusto: z.coerce.number(),
    idEnderecoFaturamento: z.coerce.number().optional(),
    idCliente: z.coerce.number().optional(),
    razaoSocial: z.string().optional(),
    nomeFantasia: z.string().optional(),
    cnpj: z.string().optional(),
    cpf: z.string().optional(),
    inscricaoEstadual: z.string().optional(),
    inscricaoMunicipal: z.string().optional(),
    telefoneFixo: z.string().optional(),
    telefoneCelular: z.string().optional(),
    email: z.string().optional(),
    contato: z.string().optional(),
    principal: z.coerce.number().int().default(1),

    // endereco 
    rua: z.string().optional().nullable(),
    numero: z.string().trim().max(9, { message: "Máximo de 9 caracteres permitidos" }).optional().nullable(),
    apartamento: z.string().optional().nullable(),
    cep: z.string().optional().nullable(),
    uf: z.string().optional().nullable(),
    cidade: z.string().optional().nullable(),
    bairro: z.string().optional().nullable(),
    pais: z.string().optional().nullable(),

});

export type InformacaoFaturamentoForm = z.infer<typeof InformacaoFaturamentoSchema>;

export const defaultInformacaoFaturamentoForm: Partial<InformacaoFaturamentoForm> = {
    idInformacaoFaturamento: 0,
    principal: 1,

};
